<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Update Meter</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>

  <mat-tab-group>
    <mat-tab label="Update Usage">
      <div class="ttmodal__body">


          <!-- <mat-form-field class="input">
            <input matInput [min]= "lastUpdateTime" [max] = "maxDate" readonly [matDatepicker]="myDatepicker" placeholderout="Date of Reading" 
            [(ngModel)]="dateOfReading" >
            <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #myDatepicker></mat-datepicker>
          </mat-form-field> -->

          <div class="input-container">
              <mat-radio-group name="type" [(ngModel)]="actionType">
                  <mat-radio-button labelPosition="before" value="1" title="SMU" #actSMU (click)="doSmu()">Update SMU</mat-radio-button>
                  <mat-radio-button labelPosition="before" value="2" title="BCM and Tons" #actBcmTon (click)="doBcmTon()">Update BCM m³/ Tons</mat-radio-button>
              </mat-radio-group>
          </div>

<div *ngIf="selectSMU">
  
          <div class="input-container">
              <span class="label">Date of Reading</span>
              <span class="input-icon input-icon--mat cursor-pointer get-icon" (click)="myDatepicker.open()" matTooltip="{{ttDate}}">
                  <i class="material-icons">date_range</i>
              </span>
              <input type="text" [matDatepicker]="myDatepicker" class="get-Input-date"
                     [min]="lastUpdateTime" [max]="maxDate" placeholder="Date of Reading"
                     [(ngModel)]="dateOfReading"
                     readonly="readonly" style="color: black">
              <mat-datepicker #myDatepicker></mat-datepicker>
          </div>

          <!-- <mat-form-field class="input">
            <input matInput placeholder="New SMU" type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="smuChangeTo" [formControl]="smuReadingInput"
              min="smuPrechange" ngDefaultControl required>
          </mat-form-field> -->

          <div class="input-container">
              <span class="label">New SMU</span>
              <input type="text" class="get-Input" (input)="onNumberInput($event, 'smuChangeTo')"   inputmode="numeric" [(ngModel)]="smuChangeTo" [formControl]="smuReadingInput" [min]="smuPrechange" ngDefaultControl required />
          </div>

          <div *ngIf="smuReadingInput.errors && (smuReadingInput.dirty || smuReadingInput.touched)">
            <mat-error *ngIf="smuReadingInput.errors.required">SMU Reading is required</mat-error>
            <mat-error *ngIf="smuReadingInput.errors.min">New SMU must be greater than previous SMU</mat-error>
          </div>
        
</div>

<div *ngIf="!selectSMU">



    <div class="input-container">
        <span class="label">Start Date</span>
        <span class="input-icon input-icon--mat cursor-pointer get-icon" (click)="myDatepicker_start.open()" matTooltip="{{ttDate}}">
            <i class="material-icons">date_range</i>
        </span>
        <input type="text" [matDatepicker]="myDatepicker_start" class="get-Input-date"
               [min]="lastUpdateTime" [max]="maxDate" placeholder="Start Date"
               [(ngModel)]="startDate"
               readonly="readonly" style="color: black">
        <mat-datepicker #myDatepicker_start></mat-datepicker>
    </div>

    <div class="input-container">
        <span class="label">End Date</span>
        <span class="input-icon input-icon--mat cursor-pointer get-icon" (click)="myDatepicker_end.open()" matTooltip="{{ttDate}}">
            <i class="material-icons">date_range</i>
        </span>
        <input type="text" [matDatepicker]="myDatepicker_end"  class="get-Input-date"
               [min]="lastUpdateTime" [max]="maxDate" placeholder="End Date"
               [(ngModel)]="endDate"
               readonly="readonly" style="color: black">
        <mat-datepicker #myDatepicker_end></mat-datepicker>
    </div>
          <div class="input-container">
              <span class="label">BCM</span>
              <input type="text" class="get-Input" (input)="onNumberInput($event, 'bcmChangeTo')" [(ngModel)]="bcmChangeTo" [formControl]="bcmReadingInput" [min]="bcmPrechange" ngDefaultControl (mouseout)="Checkvalidations()"/>
              <span class="input-icon">m³</span>
            </div>
          <!-- <div *ngIf="bcmReadingInput.errors && (bcmReadingInput.dirty || bcmReadingInput.touched)">
              <mat-error *ngIf="bcmReadingInput.errors.min && bcmReadingInput!= null">New BCM must be greater than previous BCM</mat-error>
            </div> -->

          <div class="input-container">
              <span class="label">Tons</span>
              <input type="text" class="get-Input"  (input)="onNumberInput($event, 'tonChangeTo')" [(ngModel)]="tonChangeTo" [formControl]="tonReadingInput" [min]="tonPrechange" ngDefaultControl (mouseout)="Checkvalidations()" />
              <span class="input-icon">Tons</span>
            </div>
          <!-- <div *ngIf="tonReadingInput.errors && (tonReadingInput.dirty || tonReadingInput.touched)">
              <mat-error *ngIf="tonReadingInput.errors.min">New Tonnage must be greater than previous Tonnage</mat-error>
            </div> -->
       
        <!-- <mat-form-field class="input">
          <input matInput placeholder="BCM" type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="bcmChangeTo" >
        </mat-form-field> -->


        <!-- <mat-form-field class="input">
          <input matInput placeholder="Tonnage" type="text" style="background: white; border: 0px solid #ffffff !important; " [(ngModel)]="tonChangeTo"  >
        </mat-form-field> -->
    </div>
      </div>
      <div class="ttmodal__footer">
        <button mat-raised-button (click)="onNoClick()">Cancel</button>
        <button *ngIf="selectSMU" mat-raised-button color="warn" [class.loading]="saving" (click)="updateMeterClicked()" [disabled]= "smuReadingInput.errors || !validate ">
          <!-- <span class="material-icons button__icon">check</span> -->
          <span class="button__text">Save</span>
        </button>

        <button *ngIf="!selectSMU" mat-raised-button color="warn"  (click)="updateMeterClicked()">
            <!-- <span class="material-icons button__icon">check</span> -->
            <span class="button__text">Save</span>
          </button>
      </div>
    </mat-tab>
    <mat-tab label="History">
     
      <div class="panel__content no-padding">
        <table class="table table--striped table--full-width">
          <thead>
            <tr>
              <th>Type</th>
              <th rowspan="2">Date</th>
              <th>SMU</th>
              <th>BCM for Period</th>
              <th>BCM To Date</th>
              <th>Tons for Period</th>
              <th>Tons to Date</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row-style" *ngFor="let item of SMUHistory" > 
              <td>{{item.ActionType}}</td>
              <td *ngIf="item.eDate == null" >{{item.sDate  |date: 'MMM dd yyyy'}}</td>
              <td *ngIf="item.eDate != null" >
               <tr> {{ getDate(item.sDate ) }} </tr>
               <tr>{{  getDate(item.eDate )}} </tr>
              </td>
              <td *ngIf="item.equipmentSMU == -1">-</td>
              <td *ngIf="item.equipmentSMU != -1">{{item.equipmentSMU}}</td>
              <td *ngIf="item.BCM == -1">-</td>
              <td *ngIf="item.BCM != -1">{{item.BCM}}</td>
              <td *ngIf="item.BcmTotal == -1">-</td>
              <td *ngIf="item.BcmTotal != -1">{{item.BcmTotal}}</td>

              <td *ngIf="item.TON == -1">-</td>
              <td *ngIf="item.TON != -1">{{item.TON}}</td>
              <td *ngIf="item.TonsTotal == -1">-</td>
              <td *ngIf="item.TonsTotal != -1">{{item.TonsTotal}}</td>
             
            </tr>
          </tbody>
    
    
        </table>
      </div>

      <div class="ttmodal__footer">
          <button mat-raised-button (click)="onNoClick()">Cancel</button>
          
        </div>
    </mat-tab>
  </mat-tab-group>




  
</div>
